import * as docsActions from './docs';

module.exports = {
  docsActions,
};



// WEBPACK FOOTER //
// ./actions/index.js